import "./Pagination.scss";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const Pagination = ({ page, total_pages, getCurrentPageContent }) => {
  const handleClick = (pageNumber) => {
    getCurrentPageContent(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const adjacentPageRange = 2;

    pageNumbers.push(
      <div
        className={`page ${page === 1 ? "active-page" : ""}`}
        key={1}
        onClick={() => handleClick(1)}
      >
        1
      </div>
    );

    let startPage = Math.max(page - adjacentPageRange, 2);
    let endPage = Math.min(page + adjacentPageRange, total_pages - 1);

    if (startPage > 2) {
      pageNumbers.push(
        <div className="page" key="start-ellipsis">
          ...
        </div>
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div
          className={`page ${i === page ? "active-page" : ""}`}
          key={i}
          onClick={() => handleClick(i)}
        >
          {i}
        </div>
      );
    }

    if (endPage < total_pages - 1) {
      pageNumbers.push(
        <div className="page" key="end-ellipsis">
          ...
        </div>
      );
    }

    if (total_pages > 1) {
      pageNumbers.push(
        <div
          className={`page ${page === total_pages ? "active-page" : ""}`}
          key={total_pages}
          onClick={() => handleClick(total_pages)}
        >
          {total_pages}
        </div>
      );
    }

    return pageNumbers;
  };

  const handlePrevClick = () => {
    if (page > 1) {
      handleClick(page - 1);
    }
  };

  const handleNextClick = () => {
    if (page < total_pages) {
      handleClick(page + 1);
    }
  };

  return (
    <div className="pagination">
      <span onClick={handlePrevClick}>
        <FormattedMessage id="previous" defaultMessage="Précédent" />
      </span>
      {renderPageNumbers()}
      <span onClick={handleNextClick}>
        <FormattedMessage id="next" defaultMessage="Suivant" />
      </span>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number,
  total_pages: PropTypes.number,
  getCurrentPageContent: PropTypes.func,
};

export default Pagination;
